// extracted by mini-css-extract-plugin
export var accordion = "_e3-0";
export var chevron = "_e3-3";
export var closed = "_e3-2";
export var content = "_e3-4";
export var open = "_e3-1";
export var rotate = "_e3-5";